export default "__VITE_ASSET__DBt5vtTv__"